<template>
  <div id="app">
    <el-container class="MailDestinationCont">
      <el-header>
        <div class="header-area">
        </div>
      </el-header>

      <el-main>
        <div class="header-inner-area">
          <ul>
            <li>
              <img class="logo" src="../../assets/image/logo-new.png" alt="LOGO" />
            </li>
          </ul>
        </div>
      </el-main>
    </el-container>
        <el-divider class="header-divider"></el-divider>

      
	<el-container class="main-div parentDiv">
		<el-container class="SID0020__MailDestinationSelection">
      <div class="SID0020__Container" v-if="this.show==true">
        <span>メール配信が10分を経過しています。 再度リセット処理を行ってください。</span>
      </div>
		<div class="SID0020__Container" v-else>
			<el-container>
			<el-form
				ref="form"
				:rules="rules"
				:model="form"
				class="div-form"
				label-width="auto"
			>
				<el-form-item label="企業コード" class="div-form-item" >
				<el-form-item id="label_css_left" :label="this.getContractCode0020"></el-form-item>
				</el-form-item>
				<el-form-item label="ユーザーID" class="div-form-item">
				<el-form-item id="label_css_left" :label="this.getUserId0020"></el-form-item>
				</el-form-item>
				<el-form-item label="パスワード" class="div-form-item" prop="input1">
				<el-input type="password" v-model="form.input1"></el-input>
				</el-form-item>
				<el-form-item label="パスワード(再入力)" class="div-form-item" prop="input2">
				<el-input type="password" v-model="form.input2"></el-input>
				</el-form-item>
				<el-form-item>
				<el-button type="primary" plain @click="open('form')">登録</el-button>
				<el-button type="info" @click="close()" class="button_clear_css" plain>閉じる</el-button>
				</el-form-item>
			</el-form>
			</el-container>
			<el-row class="ButtonSubmit" v-if="TableVisible">
			<el-button @click="tableClick" type="primary" plain>送信</el-button>
			</el-row>
			<el-container v-if="TableVisible">
			<el-table ref="multipleTable" :data="getTableResult1002" border style="width: 100%">
				<el-table-column type="selection"></el-table-column>
				<el-table-column property="media" label="媒体" show-overflow-tooltip="true"></el-table-column>
				<el-table-column
				property="mailaddres"
				label="メールアドレス"
				show-overflow-tooltip="false"
				></el-table-column>
				<el-table-column property="themename" label="テーマ名" show-overflow-tooltip="false"></el-table-column>
				<el-table-column property="template" label="テンプレート" show-overflow-tooltip="false"></el-table-column>
			</el-table>
			</el-container>
			<el-row class="ButtonSubmit" v-if="TableVisible">
			<el-button @click="tableClick" type="primary" plain>送信</el-button>
			</el-row>
		</div>
		</el-container>
	</el-container>
    
    <el-container class="footer-div">
        <el-footer class="footer0020 footer-element">
          <FooterComponent />
          </el-footer>
      </el-container>

  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Vue from 'vue'
import FooterComponent from "../common/footerComponent.vue"; 
import json from "../../components/config.json";
import router from '../../router';
export default {
  name: "SID0020",
  components: {
    FooterComponent
  },
  data() {
    var confirmPass = (rule, value, callback) => {
      var passCheck = this.form.input1;
      if (value != passCheck) {
        callback(new Error("Enter confirm password"));
      } else {
        callback();
      }
    };
    return {
      time:"",
      show:false,
      form: {
        input1: "",
        input2: ""
      },
      dummy: "",
      text: "",
      user_id: "",
      contract_code: "",
      TableVisible: false,
      value1: true,
      value2: true,
      value3: true,
      value4: true,
      dateoptions: [
        {
          value: "2016/09/26",
          label: "2016/09/26"
        },
        {
          value: "2016/09/27",
          label: "2016/09/27"
        },
        {
          value: "2017/09/27",
          label: "2017/09/27"
        },
        {
          value: "2017/09/26",
          label: "2017/09/26"
        },
        {
          value: "2018/09/27",
          label: "2017/09/27"
        },
        {
          value: "2018/09/26",
          label: "2017/09/26"
        },
        {
          value: "2016/09/23",
          label: "2016/09/23"
        }
      ],
      datevalue: "2016/09/23",
      themeoptions: [
        {
          value: "すべて",
          label: "すべて"
        },
        {
          value: "自社関連",
          label: "自社関連"
        },
        {
          value: "テーマグループG",
          label: "テーマグループG"
        },
        {
          value: "トピックス",
          label: "トピックス"
        }
      ],
      themevalue: "すべて",
      mediaoptions: [
        {
          value: "新聞",
          label: "新聞"
        },
        {
          value: "WEB",
          label: "WEB"
        }
      ],
      mediavalue: "新聞",
      addressoptions: [
        {
          value: "xxx＠exmaple.com",
          label: "xxx＠exmaple.com"
        }
      ],
      addressvalue: "xxx＠exmaple.com",
      multipleSelection: [],
      myWindow:'',
      rules: {
        input1: [
          { required: true, message: "パスワードを入力してください。" },
          {
            max:256,
            message: "パスワードは256文字以下を入力してください。"
          },
          { pattern:/^[/\u3040-\u30ff\u3400-\u4dbf\uf900-\ufaff\uff66-\uff9fa-zA-Z0-9-!$%^&*()_+|~=`{}[\]:";'<>?,.@#]+$/,message:'パスワードは半角英数字で入力してください。'}
        ],
        input2: [
          { required: true, message: "パスワード(再入力)を入力してください。" },
          {
            validator: confirmPass,
            message: "パスワードがパスワード(確認)と一致しないので、再入力してください。",
            trigger: "blur"
          }
        ]
      }
    };
  },

  computed: {
    ...mapGetters("situation1002", [
      "getTableResult1002",
      "getcheck",
      "getactivename",
      "getdateoptions",
      "getdatevalue",
      "getthemeoptions",
      "getthemevalue",
      "getmediaoptions",
      "getmediavalue",
      "getaddressoptions",
      "getaddressvalue"
    ]),
    ...mapGetters("situation0020", [
      "getContractCode0020",
      "getUserId0020",
      "getcheck",
      "getname",
      "getStatus",
      "getMsgCode",
      "getmsgDetail",
      "getmessageDetail"
    ])
  },
  methods: {
    // reset password from login user
    open(formName) {
      this.$LogButtonEvent("0020","Register");
			this.$LogMethodIN("0020","open");
      this.$refs[formName].validate(valid => {
        if (valid) {
          var formPassword = {
            password1: this.form.input1,
            password2: this.form.input2,
            password_resetkey:this.$route.query["k"]
          };
          this.$store.dispatch('communication0020/changePasswordDetails',formPassword).then(() => {
            var status = this.getStatus;
            if(status == 0){
              this.$alert(this.getmessageDetail, json["0020_register_success_title"], {
                confirmButtonText: 'OK',
              }).then(() => {
                router.push({name:"0001"});
              })
            }
            else if(this.getMsgCode == "MSG0027"){
              this.$alert("パスワードリセットの有効期限が過ぎています。再度パスワードリセットの手続きを行ってください", "確認", {
                confirmButtonText: 'OK',
              });

            }
            else{
              this.$alert(this.getmessageDetail, json["0020_register_failure_title"], {
                confirmButtonText: 'OK',
              });
            }
              
          })
        }
        else {
          return false;
        }
      });
      this.$LogMethodOut("0020","open");
    },
    close(){
      this.$LogButtonEvent("0020","close");
			this.$LogMethodIN("0020","close");
      window.close();
      this.$LogMethodOut("0020","close");
    }
  },
  mounted() {
    var ResetKey = this.$route.query["k"];
    var cdate = new Date();
    this.time=Vue.prototype.$session.get('time');
    var new1= new Date(this.time)
    if(cdate.getTime() > new1.getTime()){
     this.show=true;
     }else{
      console.log('show')
    }
    //Get table articles during page load
    this.$store.dispatch('communication0020/getUserDetails',ResetKey).then(() => {
      var status = this.getStatus;
      if(status == 1){
        this.$alert(this.getmsgDetail, "確認", {
          confirmButtonText: 'OK',
        });
      } 
      }).catch(err => {
      console.log(err)
    })
  },
  created() {
    //For the screen Title
    document.title = "記事閲覧";
  },
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@import "../../assets/css/style.css";
@import "0020.css";
</style>